import { MEETING_LINK_TYPE } from "./meetingLinkType"

export const DESK_BOOKING_SUBJECT = 'Desk Booking'

export const CREATE_BOOKING = {
  CALENDAR: {
    TH: 'ปฏิทิน',
    EN: 'Calendar'
  },
  ROOM: {
    TH: 'ห้องประชุม',
    EN: 'Meeting room'
  },
  CREATE_BOOKING: {
    TH: 'จองห้องประชุม',
    EN: 'Create Booking'
  },
  DATE: {
    TH: 'วันที่',
    EN: 'Date'
  },
  UPDATE_BOOKING: {
    TH: 'แก้ไขการประชุม',
    EN: 'Update Booking'
  },
  DETAIL_BOOKING: {
    TH: 'รายละเอียดการประชุม',
    EN: 'Booking Detail'
  },
  PROJECT_NAME: {
    TH: 'หัวข้อการประชุม',
    EN: 'Meeting subject'
  },
  COMPANY: {
    TH: 'บริษัท',
    EN: 'Company'
  },
  BUILDING: {
    TH: 'อาคาร',
    EN: 'Building'
  },
  FLOOR: {
    TH: 'ชั้น',
    EN: 'Floor'
  },
  SPACE_TYPE: {
    TH: 'ประเภทพื้นที่',
    EN: 'Space Type'
  },
  MEETING_SPACE: {
    TH: 'พื้นที่ประชุม',
    EN: 'Meeting Space'
  },
  ZONE: {
    TH: 'โซน',
    EN: 'Zone'
  },
  NO_ZONE: {
    TH: 'ไม่มีโซน',
    EN: 'No Zone'
  },
  OWNER: {
    TH: 'ผู้จอง',
    EN: 'Owner'
  },
  MEETING_SUBJECT: {
    TH: 'หัวข้อการประชุม',
    EN: 'Meeting Subject'
  },
  TO: {
    TH: 'ถึง',
    EN: 'to'
  },
  USER_MANUAL: {
    TH: 'คู่มือการใช้งาน',
    EN: 'User Manual'
  },
  IS_PRIVATE: {
    TH: 'ซ่อนหัวข้อการประชุม',
    EN: 'Hide meeting subject.'
  },
  Duration: {
    TH: 'ระยะเวลา',
    EN: 'Duration'
  },
  NOTIFICATION: {
    TH: 'การแจ้งเตือน',
    EN: 'Notification'
  },
  MINUTE_MARK: {
    TH: 'นาที',
    EN: 'Minutes'
  },
  PROJECT_OWNER: {
    TH: 'ผู้เชิญการประชุม',
    EN: 'Owner'
  },
  GUEST: {
    TH: 'ผู้เข้าร่วมการประชุม',
    EN: 'Guests'
  },
  ADD_GUEST: {
    TH: 'ผู้เข้าร่วมการประชุม',
    EN: 'Add guests'
  },
  INFO: {
    TH: 'รายละเอียดการประชุม',
    EN: 'Description'
  },
  CATERING: {
    TH: 'อาหาร',
    EN: 'Catering'
  },
  SELECT_CATERING: {
    TH: 'รายการอาหาร',
    EN: 'Select Catering'
  },
  SELECT_EQUIPMENT: {
    TH: 'รายการอุปกรณ์',
    EN: 'Select Equipment'
  },
  CATERING_DESCRIPTION: {
    TH: 'เพิื่มอาหารที่คุณต้องการ',
    EN: 'Add your catering.'
  },
  EQUIPMENT: {
    TH: 'อุปกรณ์',
    EN: 'Equipment'
  },
  EQUIPMENT_DESCRIPTION: {
    TH: 'เพิื่มอุปกรณ์ที่คุณต้องการ',
    EN: 'Add your equipment.'
  },
  CONTROL_DEVICES_MEETINGROOM: {
    TH: 'ควบคุมอุปกรณ์ในห้องประชุม',
    EN: 'Control room',
  },
  CONTROL_GUIDE: {
    TH: 'คู่มือการควบคุมอุปกรณ์ในห้องประชุม',
    EN: 'Room Manual',
  },
  UNIT: {
    TH: 'ชิ้น',
    EN: 'Units'
  },
  CANCEL_ORDER: {
    TH: 'ยกเลิกรายการ',
    EN: 'Cancel order'
  },
  ORDER: {
    TH: 'รายการ',
    EN: 'Order'
  },
  ORDER_STATUS_TEXT: {
    0: {
      TH: 'สำเร็จ',
      EN: 'Completed'
    },
    1: {
      TH: 'รอ',
      EN: 'Waiting'
    },
    2: {
      TH: 'กำลังดำเนินการ',
      EN: 'On-process'
    }
  },
  FOOD: {
    TH: 'อาหาร',
    EN: 'Food'
  },
  DRINK: {
    TH: 'เครื่องดื่ม',
    EN: 'Drink'
  },
  ORDER_STATUS: {
    TH: 'รายการสถานะ',
    EN: 'Order status'
  },
  SELECT_CATERING_WARNING: {
    TH: 'กรุณาเลือกห้องประชุมที่ต้องการจองก่อน',
    EN: 'Please select meeting room first.'
  },
  SELECT_START_TIME_PICKER_WARNING: {
    TH: 'ท่านยังไม่ได้เลือกห้อง, วันเริ่มต้น',
    EN: 'Please select room & date first.'
  },
  SELECT_END_TIME_PICKER_WARNING: {
    TH: 'ท่านยังไม่ได้เลือกห้อง, วันและเวลาเริ่มต้น',
    EN: 'Please select room, date & start time first.'
  },
  BOOKING_NOT_FOUND: {
    TH: 'ไม่พบรายการจองที่ของท่าน',
    EN: 'Your booking cannot be found.'
  },
  BOOKING_CONFLICT_HOLIDAY: {
    TH: 'ท่านไม่สามารถทำการจองในวันหยุดได้',
    EN: 'Booking on holiday is not allowed.'
  },
  SHOW_TIMELINE: {
    TH: 'แสดงตารางเวลาของห้อง',
    EN: 'Show room time schedule'
  },
  NO_DATA: {
    TH: 'ไม่พบข้อมูล',
    EN: 'No data.'
  },
  MORE: {
    TH: 'เพิ่มเติม',
    EN: 'more'
  },
  MEETING_LINK: {
    TH: 'ลิงก์การประชุมออนไลน์',
    EN: 'Online meeting URL',
  },
  CHARACTER: {
    TH: (amount, max) => { return `${amount} ตัวอักษร จากจำนวนสูงสุด ${max} ตัวอักษร.` },
    EN: (amount, max) => { return `${amount} of max ${max} character.` }
  },
  ADD_ONLINE_MEETING_LINK: {
    key: MEETING_LINK_TYPE.AUTO,
    TH: 'เพิ่มลิงค์การประชุมออนไลน์',
    EN: 'Add online meeting link'
  },
  NO_ONLINE_MEETING: {
    key: MEETING_LINK_TYPE.NONE,
    TH: 'ไม่มีการประชุมออนไลน์',
    EN: 'No online meeting'
  },
  AUTO_GENERATE_ONLINE_MEETING_LINK: {
    key: MEETING_LINK_TYPE.AUTO,
    TH: 'สร้างลิงค์การประชุมออนไลน์อัตโนมัติ',
    EN: 'Auto generate online meeting link'
  },
  ADD_YOUR_LINK: {
    key: MEETING_LINK_TYPE.MANUAL,
    TH: 'เพิ่มลิงค์การประชุม',
    EN: 'Add your link'
  },
  SELECT_BUILDING: {
    TH: 'เลือกอาคาร',
    EN: 'Select Building'
  },
  SELECT_FLOOR: {
    TH: 'เลือกชั้น',
    EN: 'Select Floor'
  },
  SELECT_SPACE_TYPE: {
    TH: 'เลือกประเภทพื้นที่',
    EN: 'Select Space Type'
  },
  MEETING_TOPIC_PLACEHOLDER: {
    TH: 'ระบุหัวข้อการประชุม (เช่น ประชุมประจำสัปดาห์, ประชุมกับลูกค้า)',
    EN: 'Specify the meeting topic (e.g., Weekly sync, Client meeting)'
  },
  MEETING_DETAIL_PLACEHOLDER: {
    TH: 'รายละเอียดเพิ่มเติม เช่น วัตถุประสงค์ของการประชุม หรือสิ่งที่ต้องเตรียม',
    EN: 'Additional details such as the purpose of the meeting or what needs to be prepared.'
  },
  SEARCH_PARTICIPANTS: {
    TH: 'ค้นหาหรือเลือกผู้เข้าร่วม',
    EN: 'Search or select participants'
  },
  MEETING_LINK_PLACEHOLDER: {
    TH: 'ลิงค์',
    EN: 'Link'
  },
  HOUR: {
    TH: 'ชั่วโมง',
    EN: 'hour'
  },
  HOURS: {
    TH: 'ชั่วโมง',
    EN: 'hours'
  },
  UNSAVED_CHANGES_HEADER: {
    TH: 'ยังไม่ได้บันทึกการเปลี่ยนแปลง',
    EN: 'Unsaved changes'
  },
  UNSAVED_CHANGES_CONTENT: {
    TH: 'คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก\nต้องการออกจากหน้านี้ใช่หรือไม่?',
    EN: 'You have unsaved changes.\nAre you sure you want to leave this page?'
  },
  LEAVE_PAGE: {
    TH: 'ออกจากหน้านี้',
    EN: 'Leave'
  },
  STAY_ON_PAGE: {
    TH: 'อยู่ต่อ',
    EN: 'Stay here'
  },
  GUEST_EMAIL_DUPLICATE: {
    TH: 'อีเมลนี้ถูกเพิ่มแล้ว',
    EN: 'This email has already been added.'
  },
  SEARCHING: {
    TH: 'กำลังค้นหา...',
    EN: 'Searching...'
  }
}

export const ISSUE = {
  ISSUE: {
    TH: 'แจ้งปัญหา',
    EN: 'Issue Case'
  },
  ISSUE_COMPLETE: {
    TH: 'แจ้งปัญหาสำเร็จ',
    EN: 'Issue case complete.'
  },
  ADD: {
    TH: 'เพิ่ม แจ้งปัญหา',
    EN: 'Add Issue Case'
  },
  CHOOSE_ISSUE: {
    TH: 'เลือกปัญหา',
    EN: 'Choose Issue Item'
  },
  DETAIL: {
    TH: 'รายละเอียด',
    EN: 'Issue detail'
  },
  TEXT_DETAIL: {
    TH: 'รายละเอียดสิ่งของ',
    EN: 'What\'s happening?'
  },
  UPLOAD_IMG: {
    TH: 'เพิ่มรูปภาพ',
    EN: 'Upload photo'
  },
  CHOOSE_FILE: {
    TH: 'เลือกไฟล์',
    EN: 'Choose file'
  },
  TEXT_UPLOAD: {
    TH: 'JPG หรือ PNG เท่านั้น. ขนาดแนะนำ 1200 x 628 pixels. (Maximum 2M)',
    EN: 'JPG or PNG are allowed. Need to be at least 1200 x 628 pixels. (Maximum 2M)'
  },
  LIMIT_FILE: {
    TH: 'มีปัญหา กรุณาอัพโหลดไฟล์ ไม่เกิน 2 MB',
    EN: 'is fail, Please upload file least then 2 MB'
  },
  BACK: {
    TH: 'กลับ',
    EN: 'Back'
  },
  SAVE: {
    TH: 'บันทึก',
    EN: 'Save'
  },
  OTHERS: {
    TH: 'อื่น ๆ',
    EN: 'Others',
  }
}

export const EDIT_CATERING = {
  ORDER: {
    TH: 'รายการสั่ง',
    EN: 'Order'
  },
  DETAIL_ORDER: {
    TH: 'ข้อมูลรายการ',
    EN: 'Your order detail.'
  },
  MEETING_ROOM: {
    TH: 'ห้องประชุม',
    EN: 'Meeting room'
  },
  OWNER: {
    TH: 'ผู่จอง',
    EN: 'Owner'
  },
  ORDER_DATE: {
    TH: 'เวลาสั่ง',
    EN: 'Order date'
  },
  DELIVERY_DATE: {
    TH: 'เวลาส่ง',
    EN: 'Delivery date'
  },
  STATUS: {
    TH: 'สถานะ',
    EN: 'Status'
  },
  WAITING: {
    TH: 'กำลังเตรียม',
    EN: 'Waiting'
  },
  COMPLETED: {
    TH: 'เสร็จสิ้น',
    EN: 'Completed'
  },
  EDIT_CATERING: {
    TH: 'รายการอาหาร/เครื่องดืม',
    EN: 'Catering'
  },
  EDIT_CATERING_DES: {
    TH: 'คุณสามารถอัปเดตรายการอาหาร/เครื่องได้',
    EN: 'You can update catering.'
  },
  EDIT_EQUIPMENT: {
    TH: 'รายการอุปกรณ์/เครื่องประกอบ',
    EN: 'Equipment'
  },
  EDIT_EQUIPMENT_DES: {
    TH: 'คุณสามารถอัปเดตรายการอุปกรณ์/เครื่องประกอบได้',
    EN: 'You can update equipment.'
  },
  NOTE: {
    TH: 'บันทึก',
    EN: 'Note'
  },
  NOTE_DES: {
    TH: 'คุณสามารถบันทึกสิ่งที่คุณต้องการหรือแสดงความคิดเห็นกับเรา',
    EN: 'You can note anything you need or comment to us.'
  },
  CONFIRM: {
    TH: 'ยืนยันรายการ',
    EN: 'Confirm Order'
  },
  PRINT: {
    TH: 'ปริ้นรายการ',
    EN: 'Print'
  }

}

export const END_MEETING = {
  END_MEETING: {
    TH: 'จบการประชุม',
    EN: 'End Meeting'
  },
  COMPLETED: {
    TH: 'จบการประชุมเรียบร้อยแล้ว',
    EN: 'Booking is completed.'
  }
}

export const NOTIFICATION_LIST = {
  EN: [
    'None',
    '5 Minutes',
    '10 Minutes',
    '15 Minutes',
    '30 Minutes',
    '45 Minutes',
    '1 Hour',
    '1.5 Hours',
    '2 Hours',
    '3 Hours',
    '4 Hours',
    '5 Hours',
    '6 Hours',
    '7 Hours',
    '8 Hours',
    '9 Hours',
    '10 Hours',
    '11 Hours',
    '12 Hours',
    '18 Hours',
    '1 Day',
    '2 Days',
    '3 Days',
    '4 Days',
    '1 Week',
    '2 Weeks'
  ],
  TH: [
    'ไม่แจ้งเตือน',
    '5 นาที',
    '10 นาที',
    '15 นาที',
    '30 นาที',
    '45 นาที',
    '1 ชั่วโมง',
    '1.5 ชั่วโมง',
    '2 ชั่วโมง',
    '3 ชั่วโมง',
    '4 ชั่วโมง',
    '5 ชั่วโมง',
    '6 ชั่วโมง',
    '7 ชั่วโมง',
    '8 ชั่วโมง',
    '9 ชั่วโมง',
    '10 ชั่วโมง',
    '11 ชั่วโมง',
    '12 ชั่วโมง',
    '18 ชั่วโมง',
    '1 วัน',
    '2 วัน',
    '3 วัน',
    '4 วัน',
    '1 สัปดาห์',
    '2 สัปดาห์'
  ]
}

export const NOTIFICATION_TIME_LIST = [
  0,
  5,
  10,
  15,
  30,
  45,
  60,
  90,
  120,
  180,
  240,
  300,
  360,
  420,
  480,
  540,
  600,
  660,
  720,
  1080,
  1440,
  2880,
  4320,
  5760,
  10080,
  20160
]

export const BOOKING_STATUS = {
  COMPLETED: 0,
  IN_USE: 1,
  WAITING: 2,
}

export const BOOKING_MODAL = {
  VIEW_BOOKING_DETAIL: {
    TH: 'ดูรายละเอียดการจอง',
    EN: 'View Booking Detail'
  }
}

export const MEETING_INFO = {
  MEETING_INFO: {
    TH: 'ข้อมูลการประชุม',
    EN: 'Meeting Info',
  },
  MEETING_OWNER: {
    TH: 'ผู้เชิญการประชุม',
    EN: 'Meeting Owner',
  },
  DATE: {
    TH: 'วันที่',
    EN: 'Date',
  },
  DURATION: {
    TH: 'ระยะเวลา',
    EN: 'Duration',
  },
  DESCRIPTION: {
    TH: 'รายละเอียดการประชุม',
    EN: 'Description',
  },
  GUESTS: {
    TH: 'ผู้เข้าร่วมการประชุม',
    EN: 'Guests',
  },
  VIEW_ALL_GUEST: {
    TH: 'ดูผู้เข้าร่วมการประชุมทั้งหมด',
    EN: 'View All Guests',
  },
  SEE_LESS_GUEST: {
    TH: 'ย่อลง',
    EN: 'See Less',
  },
  EDIT_MEETING: {
    TH: 'แก้ไข้การประชุม',
    EN: 'Edit Meeting',
  },
  NO_GUEST: {
    TH: 'ไม่มีผู้เข้าร่วมการประชุม',
    EN: 'No Guest',
  },
  MEETING_LINK:{
    TH: 'ลิงก์การประชุม',
    EN: 'Meeting Link',
  },
  ROOM_MANUAL: {
    TH: 'คู่มือการใช้งานห้องประชุม',
    EN: 'Room Manual:',
  },
  CONTROL_ROOM: {
    TH: 'ควบคุมอุปกรณ์ในห้องประชุม',
    EN: 'Control room',
  }
}

export const ATTENDEE_CHECK_IN = {
  TITLE: {
    TH: 'เช็คอินผู้เข้าร่วม',
    EN: 'Attendee Check-in',
  },
  CHECK_IN_SUCCESS: {
    TH: 'เช็คอินสำเร็จ!',
    EN: 'Check in successful!',
  },
  ERROR_TITLE: {
    TH: 'เกิดข้อผิดพลาด',
    EN: 'Error',
  },
  ERROR_MSG: {
    TH: 'เกิดข้อผิดพลาดขณะทำการเช็คอิน',
    EN: 'An error occurred during check-in.',
  },
  FILTER_ALL: {
    TH: 'ทั้งหมด',
    EN: 'All',
  },
  CHECKED_IN: {
    TH: 'เช็คอินแล้ว',
    EN: 'Checked in',
  },
  NOT_CHECKED_IN: {
    TH: 'ยังไม่เช็คอิน',
    EN: 'Not checked in',
  },
  ALL_CHECKED_IN: {
    TH: 'เช็คอินครบทุกคนแล้ว',
    EN: 'Everyone is checked in',
  },
  DECLINED: {
    TH: 'ปฏิเสธคำเชิญ',
    EN: 'Declined',
  },
  DECLINED_COUNT: {
    TH: (count) => `ปฏิเสธคำเชิญ ${count} คน`,
    EN: (count) => `${count} declined`,
  },
  CHECK_IN_WINDOW: {
    TH: (range) => `ช่วงเวลาเช็คอิน ${range}`,
    EN: (range) => `Check-in window: ${range}`,
  },
  OUTSIDE_TIME: {
    TH: 'เช็คอินได้เฉพาะในช่วงเวลาเช็คอิน',
    EN: 'Check-in is only available during the check-in window.',
  },
  FORBIDDEN: {
    TH: 'คุณไม่มีสิทธิ์เช็คอินทั้งหมด',
    EN: 'You do not have permission to check in all guests.',
  },
  SEARCH_NAME_EMAIL_OR_PIN: {
    TH: 'ค้นหาชื่อ อีเมล หรือรหัส PIN',
    EN: 'Search name, email or PIN',
  },
  NO_MATCHING_GUEST: {
    TH: 'ไม่พบรายชื่อ',
    EN: 'No matching guest',
  },
  OWNER: {
    TH: 'เจ้าของ',
    EN: 'Owner',
  },
  COPY_PIN: {
    TH: 'คัดลอกรหัส PIN',
    EN: 'Copy PIN',
  },
  PIN_COPIED: {
    TH: 'คัดลอกแล้ว',
    EN: 'Copied',
  },
  CHECK_IN_GUEST: {
    TH: 'เช็คอิน',
    EN: 'Check in',
  },
  CONFIRM_CHECK_IN_GUEST: {
    TH: 'ยืนยัน?',
    EN: 'Confirm?',
  },
  CLICK_AGAIN_TO_CONFIRM: {
    TH: 'กดอีกครั้งเพื่อยืนยัน',
    EN: 'Click again to confirm',
  },
  CHECKING_IN: {
    TH: 'กำลังเช็คอิน...',
    EN: 'Checking in...',
  },
  CHECK_IN_ALL: {
    TH: 'เช็คอินทั้งหมด',
    EN: 'Check in All',
  },
  CHECK_IN_ALL_CONFIRM_TITLE: {
    TH: 'เช็คอินทั้งหมด?',
    EN: 'Check in all guests?',
  },
  CHECK_IN_ALL_CONFIRM_MSG: {
    TH: (count) => `ระบบจะเช็คอินให้ผู้เข้าร่วมที่ยังไม่เช็คอิน ${count} คน`,
    EN: (count) => `This will check in ${count} ${count === 1 ? 'guest' : 'guests'} who have not checked in yet.`,
  },
  CHECK_IN_GUEST_SUCCESS_MSG: {
    TH: (name) => `${name} เช็คอินเรียบร้อยแล้ว`,
    EN: (name) => `${name} has been checked in.`,
  },
  CHECK_IN_ALL_SUCCESS_MSG: {
    TH: (count) => `เช็คอินเรียบร้อย ${count} คน`,
    EN: (count) => `${count} ${count === 1 ? 'guest has' : 'guests have'} been checked in.`,
  },
  CHECK_IN_ALL_NOTHING_MSG: {
    TH: 'ไม่มีผู้เข้าร่วมที่ต้องเช็คอินแล้ว',
    EN: 'No one is left to check in.',
  },
  YOUR_CHECK_IN: {
    TH: 'การเช็คอินของคุณ',
    EN: 'Your check-in',
  },
  USE_PIN_AT_ROOM: {
    TH: 'ใช้รหัส PIN ของคุณที่ห้อง',
    EN: 'use your PIN at the room',
  },
}

export const DESK_FLOOR_PLAN = {
  DESK_SPACE: {
    TH: 'โต๊ะ',
    EN: 'Desk Space',
  },
  DESK_NAME: {
    TH: 'ชื่อโต๊ะ',
    EN: 'Desk Name',
  },
  SELECT: {
    TH: 'เลือก...',
    EN: 'Select...',
  },
  FLOOR: {
    TH: 'ชั้น',
    EN: 'Floor',
  },
  PERSONS: {
    TH: 'คน',
    EN: 'persons',
  },
  DESK: {
    TH: 'โต๊ะ',
    EN: 'Desk',
  },
  LOADING: {
    TH: 'กำลังโหลด...',
    EN: 'Loading...',
  },
  NO_DESK: {
    TH: 'ไม่มีโต๊ะในผังชั้นนี้',
    EN: 'No desks on this floor plan.',
  },
  LOAD_FAILED: {
    TH: 'โหลดสถานะโต๊ะไม่สำเร็จ',
    EN: 'Could not load desk status.',
  },
  SEARCH_BY_DESK: {
    TH: 'โต๊ะ',
    EN: 'Desk Space',
  },
  SEARCH_BY_BOOKER: {
    TH: 'ผู้จอง',
    EN: 'Booking by',
  },
  SEARCH_DESK_PLACEHOLDER: {
    TH: 'ค้นหาด้วยชื่อ...',
    EN: 'Search by name...',
  },
  SEARCH_BOOKER_PLACEHOLDER: {
    TH: 'ค้นหาด้วยชื่อหรืออีเมล...',
    EN: 'Search by name or email...',
  },
  SEARCH_NO_MATCH: {
    TH: 'ไม่พบโต๊ะที่ตรงกับการค้นหา',
    EN: 'No desks match your search.',
  },
  SEARCH_NO_MATCH_HINT: {
    TH: 'ลองค้นหาด้วยชื่ออื่น หรือเปลี่ยนประเภทการค้นหา',
    EN: 'Try another name or switch the search type.',
  },
}

export const MAX_GUEST_LIST = 5

export const ACTIVE_MEETING_ACTION = {
  END_MEETING: {
    TH: 'จบการประชุม',
    EN: 'End Meeting',
  },
  EXTEND_TIME: {
    TH: 'ต่อเวลาการประชุม',
    EN: 'Extend Time',
  },
  HEADER_END_MEETING: {
    TH: 'คุณแน่ใจไหม?',
    EN: 'Are you sure?',
  },
  CONTENT_END_MEETING: {
    TH: 'คุณต้องการสิ้นสุดการประชุมนี้หรือไม่?',
    EN: 'Do you want to end this meeting?',
  },
  BUTTON : {
    YES : {
      TH: 'ใช่ สิ้นสุดการประชุม',
      EN: 'Yes, End Meeting',
    },
    BACK : {
      TH: 'กลับ',
      EN: 'Back',
    },
  }
}

export const EXTEND_MEETING_LIST = {
  TH: [
    '15 นาที',
    '30 นาที',
    '60 นาที',
  ],
  EN: [
    '15 Minutes',
    '30 Minutes',
    '60 Minutes',
  ],
}


export const EXTEND_MEETING_TIME_LIST = [
  15,
  30,
  60,
]

export const MODAL_CRASH_BOOKING = {
  DESCRIPTION_HOLIDAY: {
    TH: 'วันที่ถูกเลือกเป็นวันหยุด',
    EN: 'The company is on holiday.'
  },
  DESCRIPTION_CONFIRM: {
    TH: 'คุณยืนยันที่จะทำรายการต่อหรือไม่',
    EN: 'Are you sure you want to proceed?'
  },
}